import React from 'react';

import {classNames} from '~/src/utilities/helpers/css';

import css from './Layout.module.scss';

interface LayoutProps {
    children: React.ReactNode;
    isCentered?: boolean;
    contentType?: string;
}

const Layout = ({children, isCentered = false, contentType = undefined}: LayoutProps) => {
    const className = classNames(css, 'layout', {isCentered}, {contentType});

    return (
        <div className={className}>
            <div className={css.content}>{children}</div>
        </div>
    );
};

export default Layout;
